import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { RoleGuard } from './guards/role.guard';

const routes: Routes = [
  {
    path: 'dashboard',
    loadChildren: () =>
      import('../modules/dashboard/dashboard.module').then((m) => m.DashboardModule),
  },

  {
    path: 'companies',
    loadChildren: () =>
      import('../modules/companies/companies.module').then((m) => m.CompaniesModule),
  },

  {
    path: 'users',
    canMatch: [RoleGuard],
    data: { roles: ['super_admin'] },
    loadChildren: () =>
      import('../modules/users/users.module').then((m) => m.UsersModule),
  },

  {
    path: 'customers',
    canMatch: [RoleGuard],
    data: { roles: ['super_admin'] },
    loadChildren: () =>
      import('../modules/customers/customers.module').then((m) => m.CustomersModule),
  },

  {
    path: 'workshops',
    canMatch: [RoleGuard],
    data: { roles: ['super_admin', 'workshop_owner'] },
    loadChildren: () =>
      import('../modules/workshops/workshops.module').then((m) => m.WorkshopsModule),
  },

  {
    path: 'workshop-leads',
    canMatch: [RoleGuard],
    data: { roles: ['super_admin'] },
    loadChildren: () =>
      import('../modules/workshop-leads/workshop-leads.module').then((m) => m.WorkshopLeadsModule),
  },

  {
    path: 'service-catalog',
    canMatch: [RoleGuard],
    data: { roles: ['super_admin'] },
    loadChildren: () =>
      import('../modules/service-catalog/service-catalog.module').then((m) => m.ServiceCatalogModule),
  },

  {
    path: 'workshop-services',
    canMatch: [RoleGuard],
    data: { roles: ['super_admin', 'workshop_owner'] },
    loadChildren: () =>
      import('../modules/workshop-services/workshop-services.module').then((m) => m.WorkshopServicesModule),
  },

  {
    path: 'payment-methods',
    canMatch: [RoleGuard],
    data: { roles: ['super_admin'] },
    loadChildren: () =>
      import('../modules/payment-methods/payment-methods.module').then((m) => m.PaymentMethodsModule),
  },

  {
    path: 'fuel-stations',
    canMatch: [RoleGuard],
    data: { roles: ['super_admin', 'fuel_station_owner'] },
    loadChildren: () =>
      import('../modules/fuel-stations/fuel-stations.module').then((m) => m.FuelStationsModule),
  },

  {
    path: 'fuel-service-catalog',
    canMatch: [RoleGuard],
    data: { roles: ['super_admin', 'fuel_station_owner'] },
    loadChildren: () =>
      import('../modules/fuel-service-catalog/fuel-service-catalog.module').then((m) => m.FuelServiceCatalogModule),
  },

  {
    path: 'fuel-station-services',
    canMatch: [RoleGuard],
    data: { roles: ['super_admin', 'fuel_station_owner'] },
    loadChildren: () =>
      import('../modules/fuel-station-services/fuel-station-services.module').then((m) => m.FuelStationServicesModule),
  },

  {
    path: 'fuel-station-payment-methods',
    canMatch: [RoleGuard],
    data: { roles: ['super_admin', 'fuel_station_owner'] },
    loadChildren: () =>
      import('../modules/fuel-station-payment-methods/fuel-station-payment-methods.module').then((m) => m.FuelStationPaymentMethodsModule),
  },

  {
    path: 'customer-vehicles',
    loadChildren: () =>
      import('../modules/customer-vehicles/customer-vehicles.module').then((m) => m.CustomerVehiclesModule),
  },

  {
    path: 'appointments',
    loadChildren: () =>
      import('../modules/appointments/appointments.module').then((m) => m.AppointmentsModule),
  },

  {
    path: 'quote-requests',
    canMatch: [RoleGuard],
    data: { roles: ['super_admin', 'workshop_owner'] },
    loadChildren: () =>
      import('../modules/quote-requests/quote-requests.module').then((m) => m.QuoteRequestsModule),
  },

  {
    path: 'tow-trucks',
    canMatch: [RoleGuard],
    data: { roles: ['super_admin', 'tow_truck_owner'] },
    loadChildren: () =>
      import('../modules/tow-trucks/tow-trucks.module').then((m) => m.TowTrucksModule),
  },

  {
    path: 'tow-truck-calls',
    canMatch: [RoleGuard],
    data: { roles: ['super_admin', 'tow_truck_owner'] },
    loadChildren: () =>
      import('../modules/tow-truck-calls/tow-truck-calls.module').then((m) => m.TowTruckCallsModule),
  },

  {
    path: 'financial',
    canMatch: [RoleGuard],
    data: { roles: ['super_admin', 'workshop_owner', 'tow_truck_owner', 'fuel_station_owner'] },
    loadChildren: () =>
      import('../modules/financial/financial.module').then((m) => m.FinancialModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CoreRoutingModule {}
